import React from "react";
import { Avatar, Skeleton } from "@material-ui/core";
import styled from "@emotion/styled";

const LoadingAvatar = styled(Avatar)`
    position: relative;
    background: transparent;
`;

const LoadingSkeleton = styled(Skeleton)`
    height: 100%;
    width: 100%;

    transform: none;
`;

export default () => (
    <LoadingAvatar>
        <LoadingSkeleton />
    </LoadingAvatar>
);
